import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from './auth.service';
import { merge, Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

@Injectable()
export class S3Service {
  constructor(private _http: HttpClient, private _authService: AuthService) {}

  public getUrlWithoutSignature(url: string): string {
    return url.substring(0, url.indexOf('?'));
  }

  public uploadFile(file: File, objectKey: string, getPresignedUrlEndpoint: string, mimeType: string = 'application/octet-stream', optHeaders?: any): Observable<string> {

    const headers = new HttpHeaders({ 'Content-Type': mimeType, ...optHeaders });

    const requestOptions = {
      headers: headers,
      responseType: 'json' as 'json'
  };
    return this._authService.getS3PresignedUrl(objectKey, mimeType, getPresignedUrlEndpoint).pipe(mergeMap(res => {
      return this._http.put<string>(res, file, requestOptions).pipe(map(() => res));
    }));
  }
}
